"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var json_1 = require("../../../../../common/helpers/json");
var saveToDisk_1 = require("../../../../../common/helpers/saveToDisk");
var time_1 = require("../../../../../common/helpers/time");
var AdminInstructorsViewScheduleController = /** @class */ (function () {
    function AdminInstructorsViewScheduleController($state, $stateParams, UsersModel, FlashService) {
        var _this = this;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.loading = true;
        this.filter = {
            start_date: new Date(new Date().setHours(0)),
            end_date: new Date(new Date().setHours(23))
        };
        this.setStartDate = this.setStartDate.bind(this);
        this.setEndDate = this.setEndDate.bind(this);
        UsersModel.getInstructorSchedule($stateParams.instructorId, {
            'start_date': (0, time_1.toYMD)(new Date(this.filter.start_date)),
            'end_date': (0, time_1.toYMD)(new Date(this.filter.end_date))
        }).then(function (response) {
            var items = _this.formatAgenda(response);
            _this.items = (0, lodash_1.sortBy)(items, function (item) {
                return item.timestamp;
            });
            _this.loading = false;
        });
    }
    AdminInstructorsViewScheduleController.prototype.formatAgenda = function (response) {
        var _this = this;
        var _allItems = [];
        if (typeof response.data.drives !== 'undefined') {
            response.data.drives.filter(function (drive) {
                drive.date = drive.drive_date;
                drive.startTime = (0, moment_1.default)(drive.start_time, 'HH:mm:s').format('h:mm a');
                drive.typeDisplay = drive.type.name;
                drive.type = 'Drive Session';
                if (drive.private === 'Y') {
                    drive.typeDisplay = drive.typeDisplay + ' (Hidden)';
                }
                drive.timestamp = (0, moment_1.default)(drive.drive_date + ' ' + drive.start_time).unix();
                if (drive.location) {
                    drive.location.address = (0, json_1.isJson)(drive.location.address) ? JSON.parse(drive.location.address) : drive.location.address;
                }
                if (drive.pickuplocation && drive.pickuplocation.hasOwnProperty('address')) {
                    drive.pickuplocation.address = drive.pickuplocation.address;
                }
                if (drive.dropofflocation && drive.dropofflocation.hasOwnProperty('address')) {
                    drive.dropofflocation.address = drive.dropofflocation.address;
                }
                var minutes = moment_1.default.duration(drive.session_length, 'minutes');
                var datetime = (0, moment_1.default)(drive.date + ' ' + drive.start_time);
                drive.endTime = (0, moment_1.default)(drive.start_time, 'HH:mm:s').add(minutes, 'minutes').format('h:mm a');
                drive.duration = moment_1.default.duration(drive.session_length, 'minutes').asHours();
                // @ts-ignore
                drive.duration = moment_1.default.duration(drive.duration, 'hours').format("h [hours], m [minutes]");
                drive.actionRequired = drive.hasUngradedReportcards === true && drive.status === "Taken" && datetime.isBefore((0, moment_1.default)());
                return drive;
            }).forEach(function (drive) {
                _allItems.push(drive);
            });
        }
        if (typeof response.data.courses !== 'undefined') {
            response.data.courses.filter(function (course) {
                course.type = 'Course';
                course.typeDisplay = course.name;
                course.location = (0, json_1.isJson)(course.location) ? JSON.parse(course.location) : course.location;
                course.timestamp = (0, moment_1.default)((0, moment_1.default)(course.date).format('YYYY-MM-DD') + ' ' + course.time).unix();
                var minutes = moment_1.default.duration(course.duration, 'minutes');
                course.endTime = (0, moment_1.default)(course.time, 'HH:mm:s').add(minutes, 'minutes').format('h:mm a');
                course.startTime = (0, moment_1.default)(course.time, 'HH:mm:s').format('h:mm a');
                course.duration = moment_1.default.duration(course.duration, 'minutes').asHours();
                // @ts-ignore
                course.duration = moment_1.default.duration(course.duration, 'hours').format("h [hours], m [minutes]");
                course.styling = 'course';
                return course;
            }).forEach(function (course) {
                _allItems.push(course);
            });
        }
        if (typeof response.data.events !== 'undefined') {
            response.data.events.filter(function (event) {
                event.typeDisplay = 'Event';
                event.type = 'Event';
                event.location = (0, json_1.isJson)(event.location) ? JSON.parse(event.location) : event.location;
                event.timestamp = (0, moment_1.default)((0, moment_1.default)(event.date).format('YYYY-MM-DD') + ' ' + event.time).unix();
                var minutes = moment_1.default.duration(event.duration, 'minutes');
                event.endTime = (0, moment_1.default)(event.time, 'HH:mm:s').add(minutes, 'minutes').format('h:mm a');
                event.startTime = (0, moment_1.default)(event.time, 'HH:mm:s').format('h:mm a');
                event.duration = moment_1.default.duration(event.duration, 'minutes').asHours();
                // @ts-ignore
                event.duration = moment_1.default.duration(event.duration, 'hours').format("h [hours], m [minutes]");
                event.styling = 'event';
                return event;
            }).forEach(function (event) {
                _allItems.push(event);
            });
        }
        if (typeof response.data.timeoffrequests !== 'undefined') {
            response.data.timeoffrequests.filter(function (rto) {
                rto.typeDisplay = 'RTO';
                var _start_ = (0, moment_1.default)(rto.begin, 'YYYY-MM-DD HH:mm:s');
                var _end_ = (0, moment_1.default)(rto.end, 'YYYY-MM-DD HH:mm:s');
                rto.timestamp = _start_.unix();
                rto.styling = 'rto';
                // Dont show times for full or range type RTO
                if (rto.type === 'full' || rto.type === 'range') {
                    var s_moment = (0, moment_1.default)(_this.filter.start_date, 'YYYY-MM-DD').hours(23).minutes(59);
                    var e_moment = (0, moment_1.default)(_this.filter.start_date, 'YYYY-MM-DD').hours(0).minutes(0);
                    rto.endTime = s_moment.format('h:mm a');
                    rto.startTime = e_moment.format('h:mm a');
                    // @ts-ignore
                    rto.duration = moment_1.default.duration(s_moment.diff(e_moment)).format("h [hours], m [minutes]");
                }
                else {
                    rto.endTime = (0, moment_1.default)(rto.end, 'YYYY-MM-DD HH:mm:s').format('h:mm a');
                    rto.startTime = (0, moment_1.default)(rto.begin, 'YYYY-MM-DD HH:mm:s').format('h:mm a');
                    // @ts-ignore
                    rto.duration = moment_1.default.duration(_end_.diff(_start_)).format("h [hours], m [minutes]");
                }
                rto.date = _start_.format('YYYY-MM-DD');
                return rto;
            }).forEach(function (rto) {
                _allItems.push(rto);
            });
        }
        return _allItems.map(function (item) {
            console.log(item);
            item.date = (0, time_1.dateStringToDate)(item.date).toLocaleDateString('en-US');
            return item;
        });
    };
    AdminInstructorsViewScheduleController.prototype.isEvent = function (item) {
        return item.type === 'Event';
    };
    AdminInstructorsViewScheduleController.prototype.isCourse = function (item) {
        return item.type === 'Course';
    };
    AdminInstructorsViewScheduleController.prototype.isDriveSession = function (item) {
        return item.type === 'Drive Session';
    };
    AdminInstructorsViewScheduleController.prototype.submit = function () {
        var _this = this;
        this.loading = true;
        this.UsersModel.getInstructorSchedule(this.$stateParams.instructorId, {
            'start_date': (0, time_1.toYMD)(new Date(this.filter.start_date)),
            'end_date': (0, time_1.toYMD)(new Date(this.filter.end_date))
        }).then(function (response) {
            var items = _this.formatAgenda(response);
            _this.items = (0, lodash_1.sortBy)(items, function (item) {
                return item.timestamp;
            });
            _this.loading = false;
        });
    };
    AdminInstructorsViewScheduleController.prototype.setStartDate = function (newDate) {
        this.filter.start_date = new Date(newDate.selected[0]);
    };
    AdminInstructorsViewScheduleController.prototype.setEndDate = function (newDate) {
        this.filter.end_date = new Date(newDate.selected[0]);
    };
    AdminInstructorsViewScheduleController.prototype.print = function () {
        var _this = this;
        this.UsersModel.printInstructorSchedule(this.$stateParams.instructorId, {
            'start_date': (0, time_1.toYMD)(new Date(this.filter.start_date)),
            'end_date': (0, time_1.toYMD)(new Date(this.filter.end_date))
        }).then(function (response) {
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            (0, saveToDisk_1.saveToDisk)(response.url);
            _this.loading = false;
        });
    };
    return AdminInstructorsViewScheduleController;
}());
AdminInstructorsViewScheduleController.$inject = ['$state', '$stateParams', 'UsersModel', 'FlashService'];
exports.default = AdminInstructorsViewScheduleController;
